import React, { useId } from "react";
import { motion } from "framer-motion";

function RotatingText({ text, radius, size }) {
  const center = size / 2;

  const id = useId();
  const circleId = `circle-${id.replace(/:/g, "")}`;

  return (
    <motion.svg
      animate={{
        rotate: 360,
      }}
      transition={{
        duration: 10,
        repeat: Infinity,
        ease: "linear",
      }}
      width={size}
      height={size}
    >
      <defs>
        <path
          id={circleId}
          d={`
            M${center},${center}
            m-${radius},0
            a${radius},${radius} 0 1,1 ${radius * 2},0
            a${radius},${radius} 0 1,1 -${radius * 2},0
          `}
        />
      </defs>

      <text fontSize="18" fill="black">
        <textPath href={`#${circleId}`}>
          {text}
        </textPath>
      </text>
    </motion.svg>
  );
}

export default RotatingText;